

export const routeToPage = (navigate, path) => {
  navigate(path);
};
